import React from 'react';
import ReactGA from 'react-ga';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './banner.css';

const Banner = () => {
  return (
    <Row className="dap_banner">
      <Col md={{ span: 5, offset: 1 }}>
        <h4>Simula tu Depósito a Plazo</h4>
        <p>Descubre una excelente alternativa de inversión.</p>
      </Col>
      <Col md={5}>
        <Link
          className="dap_btn-primary"
          to="/simulador"
          onClick={() => {
            ReactGA.event({
              category: 'Click',
              action: 'Conoce DAP'
            });
          }}
        >
          Conócelo aquí
        </Link>
      </Col>
    </Row>
  );
};

export default Banner;
